<app-integration
    [widgetRef]="widgetRef"
    [integrationInput]="integrationInput"
></app-integration>
